import { OrderStatus } from './../../enum/orders/order-status.enum';
import { OrderSideEnum } from './../../enum/orders/side.enum';
import { OrderPutOrCallEnum } from './../../enum/orders/put-or-call.enum';
import { OrderOperationEnum } from './../../enum/orders/operation.enum';
import { OrderMarketTypeEnum } from "../../enum/orders/market-type.enum";
import { OrderOriginTypeEnum } from '../../enum/orders/origin-type.enum';
import { OrderRejectTypeEnum } from '../../enum/orders/rejection-type.enum';
import { OrderValidityTypeEnum } from '../../enum/orders/validy-type.enum';
import { OrderType } from '../../enum/orders/order-type.enum';
export class Order{
    
    id: string;
    avaragePriceExecuted: number;
    orderQuantity: number;
    clOrderID: string;
    creationDate: string;
    cumQty: number;
    enteringTrade: string;
    executionDate: string;
    expirationDate: string;
    internalOrderType: OrderType;
    internalOrderTypeDescription: string;
    investorID: null;
    isDayTrade: boolean;
    isExtern: boolean;
    isStrategy: boolean;
    leavesQty: number;
    //market: OrderMarketTypeEnum;
    //marketDescription: string;
    operation: OrderOperationEnum;
    operationDescription: string;
    operationOpenValue: number;
    //orderMarketDescription: string;
    //orderMarketType: OrderMarketTypeEnum;
    orderQty: number;
    originDescription: string;
    originType: OrderOriginTypeEnum;
    paramGain: number;
    paramLoss: number;
    price: number;
    priceTrigger: number;
    priceType: number;
    priceTypeDescription: string;
    putOrCall: OrderPutOrCallEnum;
    putOrCallDescription: string;
    rejectionType: OrderRejectTypeEnum;
    rejectionTypeDescription: string;
    side: OrderSideEnum;
    sideDescription: string;
    status: OrderStatus;
    statusDescription: string;
    strategyID: string;
    symbol: string;
    text: null;
    totalExecutedValue: number;
    trades:null;
    transactionTime: string;
    updatedAt: string;
    validityType:OrderValidityTypeEnum;
    validityTypeDescription: string;
}